import P from 'prop-types';
import React, { useState, useContext, useCallback } from 'react';
import { Modal } from '../Modal';
import './styles.css';
import { Button } from '../Button';
import { GlobalContext } from '../../contexts/HomeContext';
import { Capitalize } from '../../utils/utils';
import { useNavigate } from 'react-router';
import LogoWhats from '../../img/whatsapp.png';
import LogoFacebook from '../../img/facebook.png';
import LogoInstagram from '../../img/instagram.png';
import LogoTikTok from '../../img/tiktok.png';
import LogoTwitter from '../../img/twitter.png';
import LogoYoutube from '../../img/youtube.png';

export const BarTop = () => {
  const { dadosApp, user, openPedidos, setOpenPedidos } = useContext(GlobalContext);
  const [modalMenu, setModalMenu] = useState(false);
  const [modalOpcoes, setModalOpcoes] = useState(false);
  const [modalProcura, setModalProcura] = useState(false);
  const navigate = useNavigate();
  const titleCss =
    dadosApp.Empresa.Mult.length > 1 && dadosApp.TipoApp === 'DELIVERY' ? 'calc(100% - 148px)' : 'calc(100% - 100px)';

  const userName =
    user.id <= 0 ? 'Olá, Visitante' : `Olá, ${Capitalize(user.nome === '' ? user.nome_completo : user.nome)}`;

  const fantasia = dadosApp.Empresa.Empresa.fantasia_edicao
    ? dadosApp.Empresa.Empresa.fantasia_edicao
    : dadosApp.Empresa.Empresa.fantasia;

  const whats =
    'https://api.whatsapp.com/send?text=Oi&phone=55' +
    dadosApp.Empresa.Config.whatsapp_gerencia_ddd +
    dadosApp.Empresa.Config.whatsapp_gerencia_telefone;

  const handleTitle = useCallback(() => {
    if (dadosApp.Qs.cardapioDigital === 'true') {
      return (
        <div style={{ display: 'flex', marginTop: 12, marginLeft: 80 }}>
          {dadosApp.Empresa.Config.facebook && (
            <a
              href={dadosApp.Empresa.Config.facebook}
              target="_blank"
              rel="noreferrer"
              style={{ margin: '0 7px' }}
              title="Facebook"
            >
              <img src={LogoFacebook} loading="eager" alt={'facebook'} width={'24px'} />
            </a>
          )}

          {dadosApp.Empresa.Config.instagram && (
            <a
              href={dadosApp.Empresa.Config.instagram}
              target="_blank"
              rel="noreferrer"
              style={{ margin: '0 7px' }}
              title="Instagram"
            >
              <img src={LogoInstagram} loading="eager" alt={'instagram'} width={'24px'} />
            </a>
          )}

          {dadosApp.Empresa.Config.twitter && (
            <a
              href={dadosApp.Empresa.Config.twitter}
              target="_blank"
              rel="noreferrer"
              style={{ margin: '0 7px' }}
              title="Twitter"
            >
              <img src={LogoTwitter} loading="eager" alt={'twitter'} width={'24px'} />
            </a>
          )}

          {dadosApp.Empresa.Config.youtube && (
            <a
              href={dadosApp.Empresa.Config.youtube}
              target="_blank"
              rel="noreferrer"
              style={{ margin: '0 7px' }}
              title="Youtube"
            >
              <img src={LogoYoutube} loading="eager" alt={'youtube'} width={'24px'} />
            </a>
          )}

          {dadosApp.Empresa.Config.tiktok && (
            <a
              href={dadosApp.Empresa.Config.tiktok}
              target="_blank"
              rel="noreferrer"
              style={{ margin: '0 7px' }}
              title="TikTok"
            >
              <img src={LogoTikTok} loading="eager" alt={'tiktok'} width={'24px'} />
            </a>
          )}

          {dadosApp.Empresa.Config.whatsapp_gerencia === 1 &&
            dadosApp.Empresa.Config.whatsapp_gerencia_ddd &&
            dadosApp.Empresa.Config.whatsapp_gerencia_telefone && (
              <a href={whats} target="_blank" rel="noreferrer" style={{ margin: '0 7px' }} title="WhatsApp">
                <img src={LogoWhats} loading="eager" alt={'whatsapp'} width={'24px'} />
              </a>
            )}
        </div>
      );
    }

    if (dadosApp.TipoApp === 'DELIVERY' || dadosApp.TipoApp === 'BALCAO') {
      if (fantasia) return <h4>{userName}</h4>;
      else return '';
    }
    if (dadosApp.TipoApp === 'MESA') return <h4>Mesa: {dadosApp.Mesa}</h4>;
  }, [fantasia, userName, dadosApp, whats]);

  const showCardapioSelecao = () => {
    navigate('/loja/Cardapio');
  };

  const showHidePedidos = () => {
    setOpenPedidos(openPedidos == 'none' ? 'block' : 'none');
  };

  const handleShowMenu = () => {
    if (dadosApp.TipoApp === 'DELIVERY' || dadosApp.TipoApp === 'BALCAO') {
      setModalMenu(true);
    } else setModalOpcoes(true);
  };

  const handleTitleTop = () => {
    let _title = 'Nosso Cardápio';
    if (
      dadosApp.Empresa.Config.facebook?.trim() ||
      dadosApp.Empresa.Config.instagram?.trim() ||
      dadosApp.Empresa.Config.twitter?.trim() ||
      dadosApp.Empresa.Config.tiktok?.trim() ||
      dadosApp.Empresa.Config.youtube?.trim() ||
      (dadosApp.Empresa.Config.whatsapp_gerencia === 1 &&
        dadosApp.Empresa.Config.whatsapp_gerencia_ddd?.trim() &&
        dadosApp.Empresa.Config.whatsapp_gerencia_telefone?.trim())
    ) {
      _title = 'Siga-nos:';
    }

    if (_title === 'Siga-nos:') {
      return (
        <div
          id="seletor"
          style={{
            position: 'absolute',
            marginLeft: 15,
            lineHeight: 4,
            fontSize: 12,
          }}
        >
          {_title}
        </div>
      );
    }
    return (
      <div id="seletor" style={{ width: titleCss, marginLeft: 15 }} className="title float-left">
        <h4>{_title}</h4>
      </div>
    );
  };

  return (
    <>
      <div id="top" className="barTop">
        <div className="container" style={{ paddingLeft: '0px', paddingRight: '5px' }}>
          {dadosApp.Qs.cardapioDigital === 'true' && handleTitleTop()}
          {fantasia && dadosApp.Qs.cardapioDigital !== 'true' && (
            <Button
              id="seletor"
              icon="menu"
              className="btnIcons button_menu float-left color-black"
              onClick={handleShowMenu}
            />
          )}
          {fantasia && (
            <Button
              id="seletor"
              icon="search"
              className="btnIcons button_menu float-right color-black"
              onClick={() => setModalProcura(true)}
            />
          )}
          {fantasia && dadosApp.Empresa?.Mult?.length > 1 && dadosApp.TipoApp === 'DELIVERY' && (
            <Button
              id="seletor"
              icon="restaurant_menu"
              className="btnIcons button_menu float-right color-black"
              onClick={showCardapioSelecao}
            />
          )}

          <div style={{ width: titleCss }} className="title float-left">
            {handleTitle()}
          </div>
        </div>
      </div>

      {modalMenu && (
        <Modal
          title={userName}
          isFooter={true}
          visibility={modalMenu ? 'block' : 'none'}
          param={dadosApp}
          page="MENU"
          btnOnClickClose={() => setModalMenu(false)}
        />
      )}
      {modalOpcoes && (
        <Modal
          title={'Mesa ' + dadosApp.Mesa}
          isFooter={false}
          visibility={modalOpcoes ? 'block' : 'none'}
          param={{
            origin: 'modal',
            closeModal: () => setModalOpcoes(false),
          }}
          page="OPCAO_AUTO_ATENDIMENTO"
          btnOnClickClose={() => setModalOpcoes(false)}
        />
      )}
      {modalProcura && (
        <Modal
          title="Procura"
          isFooter={false}
          visibility={modalProcura ? 'block' : 'none'}
          param={{
            closeModal: () => setModalProcura(false),
          }}
          page="PROCURA"
          btnOnClickClose={() => setModalProcura(false)}
        />
      )}
      {openPedidos.includes('block') && (
        <Modal
          title="Pedidos"
          isFooter={false}
          visibility={openPedidos}
          page="PEDIDOS"
          param={openPedidos}
          btnOnClickClose={showHidePedidos}
        />
      )}
    </>
  );
};

BarTop.propTypes = {
  title: P.string,
};
